import * as _ from "lodash";
import {BaseSensorConfigView} from "./_BaseSensorConfigView";

export class NoConfigView extends BaseSensorConfigView {

    private template = _.template(require('templates/settings/sensor_config/noconfig.html'));

    render() {
        this.$el.html(this.template({
            connector: this.con.sensor_connector,
            con: this.con,
            module: this.module,
            moduleNumber: Number(this.module.get('module_number')),
            permissionCollection: this.permissionCollection,
            installId: this.installId,
        }));

        return this;
    }

    validate() {
        return true;
    };

    hasUpdatedConfig() {
        return false;
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/settings/sensor_config/NoConfigView.ts